import { render, staticRenderFns } from "./CopyMenuDialog.vue?vue&type=template&id=4172a3ef&scoped=true&"
import script from "./CopyMenuDialog.vue?vue&type=script&lang=ts&"
export * from "./CopyMenuDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CopyMenuDialog.vue?vue&type=style&index=0&id=4172a3ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4172a3ef",
  null
  
)

export default component.exports